import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import '../pages/css/Home.css';
import '../pages/css/ProductPageUpdated.css';
import banner from '../images/hrias-banner.jpg';
import dashboard from '../images/dash.gif';
import servicebg from '../images/testimonial-bg.png';
import { FaLaptopCode, FaBrain, FaGreaterThan, FaLessThan } from 'react-icons/fa';
import { GiRobotAntennas } from 'react-icons/gi';
import { MdOutlineRocketLaunch } from 'react-icons/md';
import product1 from '../images/product1.gif';
import product2 from '../images/product2.gif';
import product3 from '../images/product3.gif';
import product4 from '../images/product4.gif';
import product5 from '../images/product5.gif';
import product6 from '../images/product6.gif';
import marketing1 from '../images/marketing1.svg';
import marketing2 from '../images/marketing2.svg';
import marketing3 from '../images/marketing3.svg';
import marketing4 from '../images/marketing4.svg';
import ct1 from '../images/ct1.jpg';
import ct2 from '../images/ct5.jpg';
import ct3 from '../images/ct2.jpg';
import ct4 from '../images/ct7.jpg';
import { FaRegCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";


function HriasPricingB2c() {
const navigate = useNavigate();

  return (
    <>

      <section className="container my-5 pricing-section">
        <div className="text-center mb-5">
          <h2 className="fw-bold">
            Choose <span style={{ color: '#fd7e14' }}>Your</span> Plan <span style={{ color: '#fd7e14' }}>- B2C</span>
          </h2>
          <p className="text-muted">Find the right package that fits your business needs.</p>
        </div>

        <div className="row justify-content-center">
          {/* Box 1 */}
          {/* Box 1 - Starter Plan */}
          <div className="col-md-4 mb-4">
            <div className="pricing-box">
              <h4 className="package-name">Starter Plan</h4>

              <button
                className="btn btn-primary mb-3"
                onClick={() => navigate("/contact-us-hrias")}
              >
                Contact Sales
              </button>

              <ul className="feature-list" style={{ fontFamily: "Poppins, sans-serif", lineHeight: "1.8" }}>

                {/* Data & Lead Generation */}
                <li><strong>Data & Lead Generation</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Highly targeted 90% verified contact database
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    50 free verified leads per month — Instagram IDs, Facebook IDs, WhatsApp Numbers
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    1 lead = 1 credit
                  </li>
                </ul>

                {/* Automated Outreach */}
                <li className="mt-2"><strong>Automated Outreach & Unlimited Follow-ups</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Unlimited automated outreach and follow-ups
                  </li>
                </ul>

                {/* Multi-channel Follow-ups */}
                <li className="mt-2"><strong>Multi-channel Follow-ups</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    WhatsApp messages with images
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Follow-ups via Instagram and Facebook
                  </li>
                </ul>

                {/* AI-powered Personalization */}
                <li className="mt-2"><strong>AI-powered Personalization</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Customized AI-generated templates (multi-channel)
                  </li>
                </ul>

                {/* Lead Sync Importer */}
                <li className="mt-2"><strong>Lead Sync Importer</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Import your leads up to 50 contacts
                  </li>
                </ul>

                {/* Integrated CRM */}
                <li className="mt-2"><strong>Integrated CRM</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Track Open, Reply, and Click-through rates
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Downloadable reports in PDF or CSV format
                  </li>
                </ul>

                {/* Enablement & Support */}
                <li className="mt-2"><strong>Enablement & Support</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    In-app live support
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Dedicated Account Manager
                  </li>
                </ul>

              </ul>
            </div>
          </div>



          {/* Box 2 - Growth Plan */}
          <div className="col-md-4 mb-4">
            <div className="pricing-box active-box position-relative">

              {/* 🔹 Top Selling Tag */}
              <span className="top-selling-tag">Top Selling</span>

              <h4 className="package-name">Growth Plan</h4>

              <button
                className="btn btn-light mb-3"
                onClick={() => navigate("/contact-us-hrias")}
              >
                Contact Sales
              </button>

              <ul
                className="feature-list"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  lineHeight: "1.8",
                  color: "white",
                }}
              >
                {/* Data & Lead Generation */}
                <li><strong>Data & Lead Generation</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Highly targeted 90% verified contact database
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    150 free verified leads per month — Instagram IDs, Facebook IDs, WhatsApp Numbers
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    1 lead = 1 credit
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Intents & signals targeting with global keyword research analysis
                  </li>
                </ul>

                {/* Automated Outreach */}
                <li className="mt-2"><strong>Automated Outreach & Unlimited Follow-ups</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Unlimited automated outreach and follow-ups
                  </li>
                </ul>

                {/* Lead Sync Importer */}
                <li className="mt-2"><strong>Lead Sync Importer</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Import your leads up to 100 contacts
                  </li>
                </ul>

                {/* Multi-channel Follow-ups */}
                <li className="mt-2"><strong>Multi-channel Follow-ups</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    WhatsApp messages with images
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Follow-ups via Instagram and Facebook
                  </li>
                </ul>

                {/* AI-powered Personalization */}
                <li className="mt-2"><strong>AI-powered Personalization</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Customized AI-generated templates (multi-channel)
                  </li>
                </ul>

                {/* Integrated CRM */}
                <li className="mt-2"><strong>Integrated CRM</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Track Open, Reply, and Click-through rates
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Downloadable reports in PDF or CSV format
                  </li>
                </ul>

                {/* Enablement & Support */}
                <li className="mt-2"><strong>Enablement & Support</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    In-app live support
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Dedicated Account Manager
                  </li>
                </ul>
              </ul>
            </div>
          </div>



          {/* Box 3 - Enterprise Plan */}
          <div className="col-md-4 mb-4">
            <div
              className="pricing-box shadow-sm p-4 rounded h-100"
              style={{
                border: "1px solid #e0e0e0",
                backgroundColor: "#fff",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              <h4 className="package-name fw-bold text-center mb-3">Enterprise Plan</h4>
              <button className="btn btn-primary d-block mx-auto mb-3" onClick={() => navigate("/contact-us-hrias")}>Contact Sales</button>
              <div>
                <ul className="feature-list" style={{ lineHeight: "1.8" }}>

                  <li><strong>Data & Lead Generation</strong></li>
                  <ul className="ps-1 list-unstyled">
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Highly targeted 90% verified contact database
                    </li>
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      250 free verified leads per month — Instagram IDs, Facebook IDs, WhatsApp Numbers
                    </li>
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Intents & signals targeting + Global keyword research analysis
                    </li>
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Automated outreach and unlimited follow-ups
                    </li>
                  </ul>

                  <li className="mt-2"><strong>Lead Sync Importer</strong></li>
                  <ul className="ps-1 list-unstyled">
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Import your leads up to 200 contacts
                    </li>
                  </ul>

                  <li className="mt-2"><strong>Multi-Channel Follow-ups</strong></li>
                  <ul className="ps-1 list-unstyled">
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      WhatsApp messages with image
                    </li>
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Follow-ups via Instagram and Facebook
                    </li>
                  </ul>

                  <li className="mt-2"><strong>AI-powered Personalization</strong></li>
                  <ul className="ps-1 list-unstyled">
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Customized AI-generated templates (Multi-channel)
                    </li>
                  </ul>

                  <li className="mt-2"><strong>Integrated CRM</strong></li>
                  <ul className="ps-1 list-unstyled">
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Open, Reply, Click-through Rates tracking
                    </li>
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Downloadable PDF/CSV reports
                    </li>
                  </ul>

                  <li className="mt-2"><strong>Enablement & Support</strong></li>
                  <ul className="ps-1 list-unstyled">
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      In-app live support with Dedicated Account Manager
                    </li>
                  </ul>

                </ul>
              </div>

            </div>
          </div>


        </div>

        {/* Add-ons Box in New Line */}
        <div className="row justify-content-center mt-5">
          <div className="col-md-8">
            <div
              className="addons-box shadow-sm p-4 rounded text-center"
              style={{ backgroundColor: "#f0f4ff", border: "1px solid #cfe2ff" }}
            >
              <h5 className="fw-bold mb-3" style={{ color: "#0d6efd" }}>
                Add-ons & Extensions
              </h5>

              <ul className="text-start ps-5" style={{ lineHeight: "1.8", listStyle: "none" }}>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  <strong>Integrations & Extensions –</strong> HubSpot, Salesforce
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  <strong>Lead Sync Importer –</strong> Import your leads to any number as per your choice, instantly integrated
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  <strong>Calling Dialer –</strong> Call recordings and download call summary
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  <strong>Custom Feature Development –</strong> Build any custom feature that you need in the portal
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  <strong>Custom Image Templates –</strong> Get image templates with visuals of your choice for emails
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  <strong>Phone Numbers of Leads –</strong> 1 phone number = 6 credits
                </li>

              </ul>
            </div>
          </div>

        </div>

      </section>


    </>
  )
}

export default HriasPricingB2c